<template>
    <v-container fluid class="user-list" v-if="languageData.calculations">
        <v-row class="ma-0">
            <v-card width="100%" class="ma-1 px-3 py-4">
                <v-card-text>
                    <v-row no-gutters justify="end" width="100%">
                        <div>
                            <v-btn height="55px" width="100%" class="search-button" color="primary" @click="openCalculationFormModal">
                                <v-icon class="mr-2">mdi-plus</v-icon>
                                {{ languageData.calculations.addCalculationBtn }}
                            </v-btn>
                        </div>  
                    </v-row>
                </v-card-text>
            </v-card>
        </v-row>
        <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-data-table
            loading-text="Loading... Please wait"
            class="users-table"
            :search="searchCalculation"
            :headers="calculationsTableHeaders"
            :options.sync="pagination"
            :server-items-length="totalItems"
            :items-per-page-options="rowsPerPageItems"
            :footer-props="footerOptions"
            :page.sync="currentPage"
            :items="calculations"
            :loading="loadingCalculations"
            mobile-breakpoint="0"
            >
            <template v-slot:item.total="{ item }">
                <span>
                {{ item.total + '€' }}
                </span>
            </template>
            <template v-slot:item.actions="{ item }">
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    @click="editCalculation(item)"
                    icon>
                    <v-icon color="fontDefault">edit</v-icon>
                </v-btn>
                </template>
                <span>{{ languageData.calculations.edit }}</span>
            </v-tooltip>
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <span v-on="on">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        @click="downloadCalculation(item)"
                        :loading="downloadCalculationIsFetching[item.id]"
                        icon>
                        <v-icon color="fontDefault">mdi-file-download</v-icon>
                    </v-btn>
                    </span>
                </template>
                <span>{{ languageData.calculations.download }}</span>
            </v-tooltip>
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    @click="showDeleteCalculationModal(item)">
                    <v-icon color="fontDefault">delete</v-icon>
                </v-btn>
                </template>
                <span>{{ languageData.calculations.delete }}</span>
            </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-row>
    <ModalInfo v-if="isShowCalculationFormModal" :layout="'modalCalculationForm'" :hidden-agree-btn="true" @clicked="hideCalculationFormModal" :show-modal="isShowCalculationFormModal">
      <template v-slot:body>
        <CalculationForm :layout="calculationFormLayout" :calculation="activeCalculation"></CalculationForm>
      </template>
    </ModalInfo>
    <ModalInfo :headModal="calculationResponseModal.head" :btnAgreeText="'Ok'" :visDisAgreeBtn="false" @clicked="hideResponseCalculationModal" :show-modal="calculationResponseModal.isVisible" :text-modal="calculationResponseModal.textInfo"></ModalInfo>
    <ModalInfo @doOperation="deleteCalculation" :isLoadingBtn="false" :headModal="deleteCalculationModal.head" :btnDisAgreeText="languageData.calculations.btnDisAgreeDeleteCalculationText" :btnAgreeText="languageData.calculations.btnAgreeDeleteCalculationText" :visDisAgreeBtn="true" @clicked="hideDeleteCalculationModal" :show-modal="deleteCalculationModal.isVisible" :text-modal="deleteCalculationModal.textInfo"></ModalInfo>
    </v-container>
</template>

<script>
import ModalInfo from "../../../../components/ModalInfo/ModalInfo.vue";
import {mapActions, mapState} from "vuex";
import eventBus from "../../../../event-bus/eventBus";
import CalculationForm from "../CalculationForm/CalculationForm.vue";
export default {
    name: "CalculationsTable",
    components: {ModalInfo, CalculationForm},
    data() {
        return {
            searchCalculation: null,
            footerOptions: {
            'items-per-page-options': [20, 50, 100],
            'disablePagination': false
            },
            currentPage: 1,
            searchTask: null,
            searchDebouceTime: 500,
            isShowCalculationFormModal: false,
            calculationFormLayout: null,
            calculationResponseModal: {
                isVisible: false,
                head: null,
                textInfo: null,
            },
            deleteCalculationModal: {
                isVisible: false,
                head: null,
                textInfo: null
            },
            activeCalculation: null,
        }
    },
    computed: {
        ...mapState("getCalculations", {
            calculations: state => state.calculations,
            calculationsTableHeaders: state => state.calculationsTableHeaders,
            totalItems: state => state.pagination.totalItems,
            rowsPerPageItems: state => state.pagination.rowsPerPage,
            sortBy: state => state.pagination.sortBy,
            loadingCalculations: state => state.loadingCalculations
        }),
        ...mapState("downloadCalculation", {
            downloadCalculationIsFetching: state => state.downloadCalculationIsFetching,
        }),

        pagination: {
            set: function(value) {
                this.searchCalculations(value);
            },
            get: function() {
                return this.$store.state.getCalculations.pagination;
            }
        }
    },
    methods: {
        ...mapActions("getCalculations", ["getCalculationsRequest", "getCalculationsHeadersTableRequest"]),
        ...mapActions("deleteCalculation", ["deleteCalculationRequest"]),
        ...mapActions("downloadCalculation", ["downloadCalculationRequest"]),

        filtersCalculations() {
            clearTimeout(this.searchTask);
            this.searchTask = setTimeout(() => {this.searchCalculations({}, true)}, this.searchDebouceTime);
        },
        searchCalculations(valueSearch={}, filters=false) {
            valueSearch.language = this.getCurrentLanguage;
            valueSearch.filters = filters;
            valueSearch.search = this.searchCalculation;
            this.getCalculationsRequest(valueSearch);
            if(filters) {
                this.currentPage = 1;
            }
        },
        openCalculationFormModal() {
            this.calculationFormLayout = 'add',
            this.isShowCalculationFormModal = true;
        },
        hideCalculationFormModal() {
            this.isShowCalculationFormModal = false;
        },
        hideResponseCalculationModal() {
            this.calculationResponseModal.head = null;
            this.calculationResponseModal.textInfo = null;
            this.calculationResponseModal.isVisible = false;
        },
        editCalculation(calculation) {
            this.activeCalculation = calculation
            this.calculationFormLayout = 'edit',
            this.isShowCalculationFormModal = true;
        },
        showDeleteCalculationModal(calculation) {
            this.activeCalculation = calculation
            this.deleteCalculationModal.head = this.languageData.calculations.deleteCalculationHead;
            this.deleteCalculationModal.textInfo = this.languageData.calculations.deleteCalculationTextInfo + ' ' + this.activeCalculation.name;      
            this.deleteCalculationModal.isVisible = true;
        },
        hideDeleteCalculationModal() {
            this.deleteCalculationModal.isVisible = false;
        },
        deleteCalculation() {
            this.deleteCalculationRequest(this.activeCalculation);
        },
        downloadCalculation(item) {
            let id = item.id;
            this.downloadCalculationRequest({ id });
        },
    },
    mounted() {
        this.updateLanguage(this.getCurrentLanguage);
        this.searchCalculations({}, true);
        eventBus.$on("setDisablePagination", (value) => {
            this.footerOptions["disablePagination"] = value;
        });
        eventBus.$on('updateVisibleCalculationResponseModal', (head, textInfo) => {
            this.calculationResponseModal.head = head;
            this.calculationResponseModal.textInfo = textInfo;
            this.calculationResponseModal.isVisible = true;
        })
        eventBus.$on('saveCalculationSuccess', () => {
            this.calculationFormLayout = null,
            this.isShowCalculationFormModal = false;
            this.filtersCalculations();
        });
        eventBus.$on('deleteCalculationSuccess', () => {
            this.activeCalculation = null;
            this.filtersCalculations();
        })
    },
}
</script>